import { cloneDeep, get, isArray, set } from 'lodash';
import { KATEGORIE_EBENE_DER_BERECHNUNNG, KOSTEN_POSITION } from '../../../../../lib/constants/constant';
import { addIndexesToPath, getIDFromResponseOption, getInitials } from '../../../../../utils/helper';
import { calculateGesamtSumme, calculateProjektDauer, calculateProjektStartJahr } from '../commonFormulas';

import Schema from '../../../../../lib/paths/antrag_FULL_Paths.json';
import KostenKategoriechema from '../../../../../lib/paths/kostenkategorie_FULL_Paths.json';
import KostenPositionSchema from '../../../../../lib/paths/kostenposition_FULL_Paths.json';
const P = Schema.attributes;
const KP_P = KostenPositionSchema.attributes;
const KK_P = KostenKategoriechema.attributes;

export const messefoerderungFormulas = (
	application: any,
	kostenKategories: any,
	vonTag: number,
	vonMonat: string,
	bisTag: number,
	bisMonat: string
) => {
	let appCopy = cloneDeep(application);
	let result: any[] = [];

	let uebernommenZeitraueme = UebernahmeProjektDaten(appCopy);
	if (isArray(uebernommenZeitraueme)) {
		for (let ele of uebernommenZeitraueme) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...uebernommenZeitraueme);

	let calcultedProjkJahr = calculateProjektStartJahr(appCopy, vonTag, vonMonat);
	let calcultedProjkdauer = calculateProjektDauer(appCopy, vonTag, vonMonat, bisTag, bisMonat);
	if (isArray(calcultedProjkJahr)) {
		for (let ele of calcultedProjkJahr) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	if (isArray(calcultedProjkdauer)) {
		for (let ele of calcultedProjkdauer) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...calcultedProjkJahr);
	result.push(...calcultedProjkdauer);

	let caculatedAusgabenSumme = calculateAusgabenSumme(appCopy);
	if (isArray(caculatedAusgabenSumme)) {
		for (let ele of caculatedAusgabenSumme) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...caculatedAusgabenSumme);

	let caculatedEinnahmenSumme = calculateEinnahmenSumme(appCopy);
	if (isArray(caculatedEinnahmenSumme)) {
		for (let ele of caculatedEinnahmenSumme) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...caculatedEinnahmenSumme);

	let uebernommenDatenInKostenPostion = uebernahmeDatenInKostenPosition(appCopy, kostenKategories);
	if (isArray(uebernommenDatenInKostenPostion)) {
		for (let ele of uebernommenDatenInKostenPostion) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...uebernommenDatenInKostenPostion);

	let caculatedBeantragteZuwendung = calculateBeantragteZuwendung(appCopy);
	if (isArray(caculatedBeantragteZuwendung)) {
		for (let ele of caculatedBeantragteZuwendung) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...caculatedBeantragteZuwendung);

	let caculatedFoerderquote = calculateFoerderQuoteGesamt(appCopy);
	if (isArray(caculatedFoerderquote)) {
		for (let ele of caculatedFoerderquote) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...caculatedFoerderquote);

	let calculatedGesamtSummeSkizze = calculateGesamtSumme(appCopy);
	if (isArray(calculatedGesamtSummeSkizze)) {
		for (let ele of calculatedGesamtSummeSkizze) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...calculatedGesamtSummeSkizze);

	return result;
};

function generateProjektAkronym(application: any) {
	let projektAkronym: string = '';
	const orgaKuerzel = get(application, P.Antragstellende_Organisation.schema.attributes.Geschaeftsbezogene_Daten_Kuerzel.path, '');
	const messeName = get(application, P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Messename.path, '');

	if (orgaKuerzel) {
		projektAkronym = orgaKuerzel + '-' + getInitials(messeName);
	} else {
		projektAkronym = getInitials(messeName);
	}

	// Kürzen auf 12 Zeichen und falls ein Minus am Ende steht, entfernen
	return projektAkronym.slice(0, 12).replace(/-$/, '');
}

function UebernahmeProjektDaten(application: any) {
	let result: any[] = [];

	const messeName = get(application, P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Messename.path, '');
	const projektKurzel = generateProjektAkronym(application);

	const messeDurchfuehrungZeitraumVon = new Date(
		get(application, P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Zeitraum_Von.path, '')
	);
	const messeDurchfuehrungZeitraumBis = new Date(
		get(application, P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Zeitraum_Bis.path, '')
	);

	result.push(
		{
			path: P.Allgemein_Projekttitel.path,
			value: messeName ? messeName : '',
		},
		{
			path: P.Allgemein_Kurzwort.path,
			value: projektKurzel ? projektKurzel : '',
		},
		{
			path: P.Allgemein_Geplante_Projektlaufzeit_von.path,
			value: messeDurchfuehrungZeitraumVon ? messeDurchfuehrungZeitraumVon : '',
		},
		{
			path: P.Allgemein_Geplante_Projektlaufzeit_bis.path,
			value: messeDurchfuehrungZeitraumBis ? messeDurchfuehrungZeitraumBis : '',
		}
	);

	return result;
}
function calculateAusgabenSumme(application: any) {
	let result: any[] = [];

	const allAusgaben = get(application, P.Foerderantrag_Kostenpositions.path, []).filter(
		(ele: any) =>
			get(ele, KP_P.Allgemein_Kostenposition.path) === KOSTEN_POSITION.Ausgabe &&
			get(ele, KP_P.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Ebene_Der_Berechnung.path) !==
				KATEGORIE_EBENE_DER_BERECHNUNNG.Oberkategorie // die Oberkategorie hier rausfiltern, sonst werden die Unterkategorie dopplet aufsummiert
	);

	const sum = allAusgaben.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);

	result.push({
		path: P.Allgemein_Geplante_Projektausgaben.path,
		value: !isNaN(sum) ? sum.toFixed(2) : 0,
	});

	// All Ausgaben mit Unterkategorie hier aufsummieren
	// i.d.R gibt es immer 5 und die Bezeichung beginnt mit 2. (z.B. 2.1 Mess.., 2.2 Mess.., usw)
	const alleAusgabenUnterkategorie = get(application, P.Foerderantrag_Kostenpositions.path, []).filter(
		(ele: any) =>
			get(ele, KP_P.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Ebene_Der_Berechnung.path) ===
			KATEGORIE_EBENE_DER_BERECHNUNNG.Unterkategorie
	);
	const unterkategorieSumme = alleAusgabenUnterkategorie.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);

	const oberKategorieIndex = get(application, P.Foerderantrag_Kostenpositions.path, []).findIndex(
		(ele: any) =>
			get(ele, KP_P.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Ebene_Der_Berechnung.path) ===
			KATEGORIE_EBENE_DER_BERECHNUNNG.Oberkategorie
	);

	result.push({
		path: addIndexesToPath(
			P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Geplante_Gesamtsumme.path,
			[`${oberKategorieIndex}`],
			['Foerderantrag_Kostenpositions']
		),
		value: !isNaN(unterkategorieSumme) ? unterkategorieSumme : 0,
	});

	return result;
}
function calculateEinnahmenSumme(application: any) {
	let result: any[] = [];

	const allAusgaben = get(application, P.Foerderantrag_Kostenpositions.path, []).filter(
		(ele: any) => get(ele, KP_P.Allgemein_Kostenposition.path) === KOSTEN_POSITION.Einnahme
	);

	const sum = allAusgaben.reduce((acc: any, ele: any) => {
		return acc + parseFloat(get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
	}, 0);

	result.push({
		path: P.Allgemein_Eingebrachte_Eigen_Und_Drittmittel.path,
		value: !isNaN(sum) ? sum.toFixed(2) : 0,
	});

	return result;
}
function uebernahmeDatenInKostenPosition(application: any, kostenKategories: any) {
	let result: any[] = [];

	const allKostenPositions = get(application, P.Foerderantrag_Kostenpositions.path, []);
	for (let i = 0; i < allKostenPositions.length; i++) {
		const eachKostenPostion = allKostenPositions[i];
		const geplanntGesamtSumme = get(eachKostenPostion, KP_P.Allgemein_Geplante_Gesamtsumme.path, 0);
		// Kostenkategories
		const selectedKostenKategorieId = getIDFromResponseOption(get(eachKostenPostion, KP_P.Allgemein_Kostenkategorie.path, ''));
		const selectedKostenKategorie_Obj = kostenKategories.find((ele: any) => get(ele, 'id') === selectedKostenKategorieId);
		const selectedKostenKategorieName = get(selectedKostenKategorie_Obj, KK_P.Allgemein_Bezeichnung.path, '');
		const allgemeinKostenProJahrBlock = [
			{
				...get(eachKostenPostion, `${KP_P.Allgemein_Kosten_Pro_Jahr.path}.0`),
				Zelle_1: get(application, P.Allgemein_Projektstart_Jahr.path, ''),
				Zelle_2: !isNaN(geplanntGesamtSumme) ? geplanntGesamtSumme : '',
			},
		];

		result.push(
			{
				path: addIndexesToPath(
					P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Kosten_Pro_Jahr.path,
					[`${i}`],
					['Foerderantrag_Kostenpositions']
				),
				value: allgemeinKostenProJahrBlock,
			},
			{
				path: addIndexesToPath(
					P.Foerderantrag_Kostenpositions.schema.attributes.Allgemein_Bezeichnung.path,
					[`${i}`],
					['Foerderantrag_Kostenpositions']
				),
				value: selectedKostenKategorieName,
			}
		);
	}
	return result;
}
function calculateBeantragteZuwendung(_application: any) {
	let result: any[] = [];

	/**
	 * Erstmal nur auskommentieren bis Abnahme. Da HA nochmal die Formell haben wollen kann.
	 * Steht im Ticket HA-1411, dass der Antragsteller die beantragte Förderung selber eintragen muss.
	 * Wenn die Förderung wieder berechnet werden soll, muss das Feld auch readOnly sein.
	 */
	// const ausgabenSumme = get(application, P.Allgemein_Geplante_Projektausgaben.path, 0);
	// const einnahmenSumme = get(application, P.Allgemein_Eingebrachte_Eigen_Und_Drittmittel.path, 0);

	// const BeantragteFoerderung = ausgabenSumme - einnahmenSumme;

	// result.push({
	// 	path: P.Allgemein_Beantragte_Zuwendung.path,
	// 	value: !isNaN(BeantragteFoerderung) ? BeantragteFoerderung.toFixed(2) : 0,
	// });

	return result;
}
function calculateFoerderQuoteGesamt(application: any) {
	let result: any[] = [];

	const ausgabenSumme = get(application, P.Allgemein_Geplante_Projektausgaben.path, 0);
	const einnahmeSumme = get(application, P.Allgemein_Eingebrachte_Eigen_Und_Drittmittel.path, 0);
	const beantragteZuwendung = get(application, P.Allgemein_Beantragte_Zuwendung.path, 0);

	const BeantragteFoerdeQuote = ausgabenSumme !== 0 ? (beantragteZuwendung / ausgabenSumme) * 100 : 0;

	result.push(
		{
			path: P.Orga_Foerderquote_Gesamt.path,
			value: !isNaN(BeantragteFoerdeQuote) ? BeantragteFoerdeQuote.toFixed(2) : 0,
		},
		{
			path: P.Bewilligung_Foerderquote_Gesamt.path,
			value: !isNaN(BeantragteFoerdeQuote) ? BeantragteFoerdeQuote.toFixed(2) : 0,
		},
		{
			path: P.Allgemein_Foerderquote_Gesamt.path,
			value: !isNaN(BeantragteFoerdeQuote) ? BeantragteFoerdeQuote.toFixed(2) : 0,
		},
		{
			path: P.Antragstellende_Organisation_Foerderquote.path,
			value:
				!isNaN(BeantragteFoerdeQuote) ?
					[{ Projektjahr: get(application, P.Allgemein_Projektstart_Jahr.path), Foerderquote_403741: BeantragteFoerdeQuote.toFixed(2) }]
				:	[],
		},
		{
			path: P.Bewilligung_Jahresaufteilung.path,
			value:
				!isNaN(BeantragteFoerdeQuote) ?
					[
						{
							Projektjahr: get(application, P.Allgemein_Projektstart_Jahr.path),
							Ausgaben: !isNaN(ausgabenSumme) ? ausgabenSumme : 0,
							Eigen_45_Und_Drittmittel: !isNaN(einnahmeSumme) ? einnahmeSumme : 0,
							Zuwendung: !isNaN(beantragteZuwendung) ? beantragteZuwendung : 0,
							Foerderquote_403741: BeantragteFoerdeQuote.toFixed(2),
						},
					]
				:	[],
		}
	);

	return result;
}
